module.exports = __webpack_public_path__ + "img/T2B_xh_10.b88359da.png";